module.exports = __webpack_public_path__ + "static/media/ThanksImg.eed1ea8c.svg";